import { useLocation, useNavigate } from "react-router-dom";
import Terminated from "../../components/Terminated/Terminated";
import { useEffect } from "react";

const ExitPage = () => {
  const { state } = useLocation();
  const { restart = true } = state || {};
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handlePopState = () => {
      navigate("/exit");
    };

    window.history.pushState(null, "", location.pathname);
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate]);

  return (
    <Terminated
      title="서비스를 종료했습니다"
      description={["다시 이용하려면 서비스 재시작 버튼을 눌러주세요"]}
      restart={restart}
      link={"/landing"}
    />
  );
};

export default ExitPage;
